import fancybox from '@/AsyncModules/fancybox';
import scrollToHash from './esm/scroll-to-hash';
import pageSpecific from './esm/page-specific';
import dropdown from './esm/dropdown';
import fromTo from './esm/fromTo';

export default el => {
  /**
   * update i-ua_js_ class
   */
  $('html').removeClass('i-ua_js_no').addClass('i-ua_js_yes');

  const $rootEl = !(el instanceof $) ? $(el) : el;

  fancybox('.fancybox');

  document.addEventListener(
    'click',
    event => {

      const $link = event.target.closest('a[href^="#"]');

      if ($link) {
        event.preventDefault();

        const hash = $link.getAttribute('href');

        if (hash === '#') {
          return;
        }

        scrollToHash(hash, 500);
      }
    },
    false
  );

  pageSpecific();

  dropdown();

  fromTo();
}



// WEBPACK FOOTER //
// ./templates/floor/assets/js/jQueryApplication/common.js